'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkerShapeForResource;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ajaxShape = require('../utils/ajaxShape');

var _ajaxShape2 = _interopRequireDefault(_ajaxShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resourceActionShape = _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape(_ajaxShape2.default)]);

// # Resource接口定义，并提供校验是否合法的方法
function checkerShapeForResource(resource, location) {
  var shapeTypes = {};
  for (var key in resource) {
    shapeTypes[key] = resourceActionShape;
  }
  return _propTypes2.default.checkPropTypes(shapeTypes, resource, location, 'Beatle');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/resource.js
// module id = 180
// module chunks = 0